import { createAction } from "redux-actions";

export const actionTypes = {
    GET_LIST: "superApp/GET_LIST",
    GET_DETAIL: "superApp/GET_DETAIL",
    UPLOAD_IMAGE: "superApp/UPLOAD_IMAGE",
    UPLOAD_BUNDLE: "superApp/UPLOAD_BUNDLE",
    UPDATE_INFO: "superApp/UPDATE_INFO",
    UPDATE_VERSION: "superApp/UPDATE_VERSION",
    UPDATE_STATUS: "superApp/UPDATE_STATUS",
    CREATE: "superApp/CREATE",
    EXPORT: "superApp/EXPORT",
    GENERATE_TOKEN: "superApp/GENERATE_TOKEN",
    UPDATE_PRIORITY: "superApp/UPDATE_PRIORITY",
};

export const actions = {
    getList: createAction(actionTypes.GET_LIST),
    getDetail: createAction(actionTypes.GET_DETAIL),
    uploadImage: createAction(actionTypes.UPLOAD_IMAGE),
    uploadBundle: createAction(actionTypes.UPLOAD_BUNDLE),
    updateInfo: createAction(actionTypes.UPDATE_INFO),
    updateVersion: createAction(actionTypes.UPDATE_VERSION),
    updateStatus: createAction(actionTypes.UPDATE_STATUS),
    create: createAction(actionTypes.CREATE),
    export: createAction(actionTypes.EXPORT),
    generateToken: createAction(actionTypes.GENERATE_TOKEN),
    updatePriority: createAction(actionTypes.UPDATE_PRIORITY),
};
